/**
 * Ob der Freigabe-Knopf in „Mein Portfolio" erscheint und was er sagt —
 * eigene, reine Funktion statt Bedingung im JSX (Muster wie `planAnzeige.ts`
 * und `wachstum.ts`).
 *
 * Zwei Regeln aus der Zielrunde-Spec, beide fachlich, keine reine
 * Formatierungsfrage:
 *
 *  - Ist die Runde eingefroren, verschwindet der Knopf — er wird nicht nur
 *    gesperrt. Danach gibt es nichts mehr freizugeben, die Zahlen stehen
 *    fest (Änderungen laufen ab dann über die Segment-Führung mit
 *    Begründung, nicht mehr über die Freigabe).
 *  - Ein Service Lead setzt NUR die eigene Freigabe. Die eigene Zeile wird
 *    über die `employeeId` in `leads` gesucht; taucht sie dort nicht auf
 *    (z. B. noch keine Beauftragung im Segment), gibt es nichts freizugeben.
 */
export type FreigabeKnopfState = {
  /** true = bereits freigegeben (Knopf nimmt zurück), false = noch offen. */
  freigegeben: boolean;
  labelKey:
    | "pages.kpi.zielrunde.freigabeZuruecknehmen"
    | "pages.kpi.zielrunde.freigeben";
};

export function freigabeKnopfState(
  status: "offen" | "eingefroren" | undefined,
  leads:
    | ReadonlyArray<{ employeeId: string; freigegebenAt: string | null }>
    | undefined,
  employeeId: string | null | undefined,
): FreigabeKnopfState | null {
  if (status !== "offen") return null;
  if (!employeeId) return null;
  const eigene = (leads ?? []).find((l) => l.employeeId === employeeId);
  if (!eigene) return null;
  const freigegeben = eigene.freigegebenAt !== null;
  return {
    freigegeben,
    labelKey: freigegeben
      ? "pages.kpi.zielrunde.freigabeZuruecknehmen"
      : "pages.kpi.zielrunde.freigeben",
  };
}
